import './About.css'

export default function About(props) {  

    // const [myStyle, setMyStyle] = useState({
    //     color: "black",
    //     backgroundColor: "white"
    // })
     
    // const [btnText, setBtnText] = useState("Enable Dark Mode")

    // const toggleMode = () => {
    //     if(myStyle.color === "black"){//light mode
    //         setMyStyle(
    //             {
    //                 color: "white",
    //                 backgroundColor: "black",
    //                 border: "1px solid white"
    //             })
    //         // setBtnText("Enable Light Mode")
    //     }else{// dark mode
    //         setMyStyle({color: "black", backgroundColor: "white"})
    //         // setBtnText("Enable Dark Mode")
    //     }
    // }

  return (
    <div>
      <div
        className="accordion"
        id="accordionExample"
        style={{
          backgroundColor: props.mode === "light" ? "white" : "#585858",
          color: props.mode === "light" ? "black" : "white", marginTop: '50px'
        }}
      >
        <h1 className="p-4" style={{color: props.mode === "light" ? "#4ecca3" : "white"}}>About Us</h1>
        <div
          className="accordion-item"
          style={{
            backgroundColor: props.mode === "light" ? "white" : "grey",
            color: props.mode === "light" ? "black" : "white",
          }}
        >
          <h2 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              style={{
                backgroundColor: props.mode === "light" ? "white" : "#585858",
                color: props.mode === "light" ? "black" : "white",
              }}
            >
              <h4>Who We Are </h4>
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              TextTidy is a dynamic, easy-to-use tool designed to help users
              streamline their text processing tasks. Whether you're a student,
              professional, or casual user, our suite of tools provides fast,
              reliable solutions for managing text—without the hassle. From
              formatting to counting words, TextTidy is your one-stop solution
              for efficient text handling.
            </div>
          </div>
        </div>
        <div
          className="accordion-item"
          style={{
            backgroundColor: props.mode === "light" ? "white" : "grey",
            color: props.mode === "light" ? "black" : "white",
          }}
        >
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
              style={{
                backgroundColor: props.mode === "light" ? "white" : "#585858",
                color: props.mode === "light" ? "black" : "white",
              }}
            >
              <h4>What We Offer</h4>
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              At TextTidy, we offer a wide range of text manipulation
              features, including text transformation (uppercase, lowercase),
              word and character counting, removing extra spaces, and more. Our
              platform is built to simplify and speed up your writing tasks,
              ensuring you can focus on what matters most—your content. The
              interface is user-friendly and designed to cater to people of all
              skill levels.
            </div>
          </div>
        </div>
        <div
          className="accordion-item"
          style={{
            backgroundColor: props.mode === "light" ? "white" : "grey",
            color: props.mode === "light" ? "black" : "white",
          }}
        >
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
              style={{
                backgroundColor: props.mode === "light" ? "white" : "#585858",
                color: props.mode === "light" ? "black" : "white",
              }}
            >
              <h4>Our Mission</h4>
            </button>
          </h2>
          <div
            id="collapseThree"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              Our mission at TextTidy is simple: to provide a fast, efficient,
              and reliable platform that enhances productivity for users working
              with text. We believe in making technology accessible, offering
              robust tools that solve common problems, and helping people work
              smarter, not harder. TextTidy continues to evolve to meet the
              needs of users from all walks of life.
            </div>
          </div>
        </div>
      </div>
      {/* <div className="container my-3">
            <button className="btn btn-primary" onClick={toggleMode}>{btnText}</button>
      </div> */}
    </div>
  );
}
